import { render, staticRenderFns } from "./RankingQuotaEditor.vue?vue&type=template&id=41cd7967&scoped=true"
import script from "./RankingQuotaEditor.vue?vue&type=script&lang=js"
export * from "./RankingQuotaEditor.vue?vue&type=script&lang=js"
import style0 from "./RankingQuotaEditor.vue?vue&type=style&index=0&id=41cd7967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd7967",
  null
  
)

export default component.exports